import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="border-t border-gray-200 dark:border-gray-700 bg-background-light dark:bg-background-dark mt-auto">
      <div className="container mx-auto px-4 py-6">
        <div className="flex flex-col md:flex-row justify-between items-center text-sm text-secondary">
          <div className="mb-4 md:mb-0">
            <p>&copy; 2025 Lantean-DEV. All rights reserved.</p>
          </div>
          <div>
            <Link
              to="/terms-and-conditions"
              className="text-primary-600 dark:text-primary-400 hover:underline"
            >
              Terms & Conditions
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
